import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bacffc9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6bacffc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bacffc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bacffc9')) {
      api.createRecord('6bacffc9', component.options)
    } else {
      api.reload('6bacffc9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bacffc9&scoped=true&", function () {
      api.rerender('6bacffc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deposit/examine/index.vue"
export default component.exports